import React from "react";
import PropTypes from "prop-types";
import LiveListingDetails from "../listing/LiveListingDetails";

function LiveListing({ listingRecordId }) {
  return (
    <LiveListingDetails
      key={listingRecordId}
      listingRecordId={listingRecordId}
    />
  );
}

LiveListing.propTypes = {
  listingRecordId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired
};

export default LiveListing;
